import { render, staticRenderFns } from "./myUpLoad.vue?vue&type=template&id=1ec60ea5&"
import script from "./myUpLoad.vue?vue&type=script&lang=js&"
export * from "./myUpLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports